/**
 * 设备检测相关工具函数
 */

const userAgent = navigator.userAgent;
export const isAndroid = userAgent.indexOf("Android") > -1 || userAgent.indexOf("Linux") > -1; //android终端
export const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export const isWeixin = userAgent.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
export const isQQ = userAgent.match(/qq\//i);
export const isHonor = userAgent.match(/honor/i);
export const isXiaomi= userAgent.match(/mi\s/i) || userAgent.match(/xiaomi/i);

//获取安卓系统版本号，非安卓返回 -1
export const getAndroidVersion = (): number => {
  const match = userAgent.match(/Android\s([\d.]+)/);
  return match ? parseFloat(match[1]) : -1;
};
//获取 iOS 系统版本号，非 iOS 返回 -1
export const getIOSVersion = (): number => {
  const match = userAgent.match(/OS\s(\d+)[_](\d+)/);
  return match ? Number(match[1]) : -1;
};
//低端设备：安卓 9 及以下 / iOS 13 以下（老 WebView 内核布局与新特性兼容性差）
export const isLowEndDevice =
  (isAndroid && getAndroidVersion() > 0 && getAndroidVersion() <= 9) ||
  (isIOS && getIOSVersion() > 0 && getIOSVersion() < 13);
//判断手机型号

export const getPhone = (model?: string) => {
  const ua = model ? model : userAgent.toLowerCase();
  const isIphone = ua.match(/iphone/i);
  const isHuawei = ua.match(/huawei/i);
  const isHonor = ua.match(/honor/i);
  const isOppo = ua.match(/oppo/i);
  const isOppoR15 = ua.match(/pacm00/i);
  const isVivo = ua.match(/vivo/i);
  const isXiaomi = ua.match(/mi\s/i) || ua.match(/xiaomi/i);
  const isXiaomi2s = ua.match(/mix\s/i);
  const isRedmi = ua.match(/redmi/i);
  const isSamsung = ua.match(/sm-/i);
  if (isIphone) {
    return "iphone";
  } else if (isHuawei || isHonor) {
    return "huawei";
  } else if (isOppo || isOppoR15) {
    return "oppo";
  } else if (isVivo) {
    return "vivo";
  } else if (isXiaomi || isRedmi || isXiaomi2s) {
    return "xiaomi";
  } else if (isSamsung) {
    return "samsung";
  } else {
    return "default";
  }
};

export const getDevice = () => {
  let agent = userAgent.toLowerCase();
  if (/windows/.test(agent)) {
    return "Windows pc";
  } else if (/iphone|ipod/.test(agent) && /mobile/.test(agent)) {
    return "iPhone";
  } else if (/ipad/.test(agent) && /mobile/.test(agent)) {
    return "iPad";
  } else if (/android/.test(agent) && /mobile/.test(agent)) {
    return "Phone";
  } else if (/linux/.test(agent)) {
    return "Linux pc";
  } else if (/mac/.test(agent)) {
    return "Mac";
  } else {
    return "other";
  }
};

export const getPlatform = () => {
  let os = {
    platform: navigator.platform.toLowerCase()
  };
  return os;
};

/** 浏览器环境类型，返回稳定的英文 code（上报文案由各业务自行映射） */
export type BrowserType =
  | "wecom"
  | "wechat"
  | "qq"
  | "douyin"
  | "weibo"
  | "uc"
  | "huawei"
  | "xiaomi"
  | "oppo"
  | "vivo"
  | "samsung"
  | "edge"
  | "firefox"
  | "chrome"
  | "safari"
  | "other";

/**
 * 识别当前浏览器环境。
 * 判断顺序敏感，不能调换：
 * - 企业微信 UA 同时含 micromessenger，必须先于微信判断；
 * - 国内 App 内置浏览器与各厂商浏览器都基于 Chrome/Safari，必须排在它们之前。
 */
export const getBrowserType = (): BrowserType => {
  const agent = userAgent.toLowerCase();
  if (/wxwork/.test(agent)) return "wecom";
  if (/micromessenger/.test(agent)) return "wechat";
  if (/mqqbrowser|qq\//.test(agent)) return "qq";
  if (/aweme|bytedancewebview|bytelocale|ttwebview/.test(agent)) return "douyin";
  if (/weibo/.test(agent)) return "weibo";
  if (/ucbrowser|ucweb/.test(agent)) return "uc";
  if (/huaweibrowser/.test(agent)) return "huawei";
  if (/miuibrowser/.test(agent)) return "xiaomi";
  if (/heytapbrowser|oppobrowser/.test(agent)) return "oppo";
  if (/vivobrowser/.test(agent)) return "vivo";
  if (/samsungbrowser/.test(agent)) return "samsung";
  if (/edg\/|edga\/|edgios\//.test(agent)) return "edge";
  if (/firefox\/|fxios\//.test(agent)) return "firefox";
  if (/chrome\/|crios\//.test(agent)) return "chrome";
  if (/safari\//.test(agent)) return "safari";
  return "other";
};

export const resizeScreen = (el: string | HTMLElement) => {
  // 利用 CSS3 旋转 对容器逆时针旋转 90 度
  const detectOrient = function () {
    let width = document.documentElement.clientWidth,
      height = document.documentElement.clientHeight;
    let $wrapper = el instanceof HTMLElement ? el : document.getElementById(el), // 这里是页面最外层元素
      style = "";
    if (width >= height) {
      console.log("横屏!!!!!");
      // 横屏
      style += "width:" + width + "px;"; // 注意旋转后的宽高切换
      style += "height:" + height + "px;";
      style += "-webkit-transform: rotate(0); transform: rotate(0);";
      style += "-webkit-transform-origin: 0 0;";
      style += "transform-origin: 0 0;";
    } else {
      console.log("竖屏!!!!!");
      // 竖屏
      style += "width:" + height + "px;";
      style += "height:" + width + "px;";
      style += "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
      // 注意旋转中点的处理
      style += "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;";
      style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    }
    $wrapper && ($wrapper.style.cssText = style);
  };
  window.onresize = detectOrient;
  detectOrient();
};
